import * as React from "react";
import ListUserCard from "./ListProCard";

export default function ListView(props) {
  const { pros, deleteUser, addToShortlist } = props;
  return (
    <div
      className="grid gap-4"
      style={{ gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))" }}
    >
      {pros.map((pro) => {
        return (
          <ListUserCard
            key={pro.userid}
            pro={pro}
            addToShortlist={addToShortlist}
            deleteUser={deleteUser}
          />
        );
      })}
    </div>
  );
}
